import service from '@/utils/request'; // UpdateUserInfo 更新用户信息
// @Tags UserInfo
// @Summary 更新用户信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body model.UserModel true "更新用户信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /userManage/user/update [put]

export var updateUserInfo = function updateUserInfo(params) {
  return service({
    url: '/userManage/user/update',
    method: 'put',
    params: params
  });
}; // FindUserInfo 根据UID查询用户
// @Tags UserInfo
// @Summary 根据UID查询用户
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.UserSimple true "根据UID查询用户"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /userManage/user/find [get]

export var findUserInfo = function findUserInfo(params) {
  return service({
    url: '/userManage/user/find',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 分页获取用户列表
// @Tags UserInfo
// @Summary 分页获取用户列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "分页获取用户列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getUserInfoList = function getUserInfoList(params) {
  return service({
    url: '/userManage/user/getList',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 分页获取微信绑定审核列表
// @Tags UserInfo
// @Summary 分页获取微信绑定审核列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "分页获取微信绑定审核列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getRetailAssistantLoginAuditList = function getRetailAssistantLoginAuditList(params) {
  return service({
    url: '/user/retailAssistantLoginAuditList',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 微信绑定审核提交
// @Tags UserInfo
// @Summary 微信绑定审核提交
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "微信绑定审核提交"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postRetailAssistantLoginAudit = function postRetailAssistantLoginAudit(data) {
  return service({
    url: '/user/retailAssistantLoginAudit',
    method: 'post',
    data: data
  });
}; // GetUserInfoList 微信绑定审核删除
// @Tags UserInfo
// @Summary 微信绑定审核删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "微信绑定审核删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getRetailAssistantLoginDel = function getRetailAssistantLoginDel(params) {
  return service({
    url: '/user/retailAssistantLoginDel',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 收银端白名单列表
// @Tags UserInfo
// @Summary 收银端白名单列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "收银端白名单列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getCashierSerialList = function getCashierSerialList(params) {
  return service({
    url: 'user/getCashierSerialList',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 收银端白名单删除
// @Tags UserInfo
// @Summary 收银端白名单删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "收银端白名单删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var getDelCashierSerial = function getDelCashierSerial(params) {
  return service({
    url: 'user/delCashierSerial',
    method: 'get',
    params: params
  });
}; // GetUserInfoList 收银端白名单提交
// @Tags UserInfo
// @Summary 收银端白名单提交
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "收银端白名单提交"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/user/getList [get]

export var postCreateCashierSerialList = function postCreateCashierSerialList(data) {
  return service({
    url: '/user/createCashierSerial',
    method: 'post',
    data: data
  });
}; // getSmsList 验证码列表
// @Tags UserInfo
// @Summary 验证码列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.UserSearch true "验证码列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /userManage/sms/getList [get]

export var getSmsList = function getSmsList(params) {
  return service({
    url: '/userManage/sms/getList',
    method: 'get',
    params: params
  });
};